import { t } from 'i18next';
import * as Yup from 'yup';

export function setValidationRules() {
  Yup.addMethod(Yup.string, 'email', function validateEmail(message = t('INVALID_EMAIL')) {
    const emailRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return this.matches(emailRegex, {
      message: message,
      name: 'email',
      excludeEmptyString: true
    });
  });

  Yup.addMethod(Yup.string, 'phone', function () {
    return this.test('phone', t('INVALID_PHONE'), function (value) {
      if (value) {
        const phoneRegex = /^[+]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{1,8}$/;

        if (!phoneRegex.test(value)) {
          return false;
        }
      }

      return true;
    });
  });

  Yup.addMethod(Yup.string, 'bringgEmail', function validateEmail(message = t('INVALID_BRINGG_EMAIL')) {
    const emailRegex = /^.+@bringg\.com$/;

    return this.matches(emailRegex, {
      message: message,
      name: 'bringgEmail',
      excludeEmptyString: true
    });
  });

  // TODO BRNGG-27306
  // Yup.addMethod(Yup.string, 'nullableMinMax', function (min, max) {
  //   return this.test('nullableMinMax', 'Invalid string length', function (value) {
  //     if (value === undefined || value === null || value === '') {
  //       return true;
  //     }
  //
  //     const label = this.schema.spec.label;
  //
  //     const minValidation = Yup.string().min(min);
  //     const maxValidation = Yup.string().max(max);
  //
  //     const minValid = minValidation.isValidSync(value);
  //     const maxValid = maxValidation.isValidSync(value);
  //
  //     if (!minValid) {
  //       return this.createError({ path: this.path, message: t('SHOULD_BE_AT_LEAST', { label, min }) });
  //     }
  //
  //     if (!maxValid) {
  //       return this.createError({ path: this.path, message: t('SHOULD_NOT_EXCEED', { label, max }) });
  //     }
  //
  //     return true;
  //   });
  // });
}
